import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import Button from 'carbon-react/lib/components/button';

import { ROUTES, getForecastByIdOnboardingUrl } from '@futrli/shared-services';

import * as styles from '../forecasting-onboarding.scss';
import { OnboardingPageTitle } from '../components/onboarding-page-title';
import { OnboardingPredictionsRouter } from '../components/onboarding-predictions-router';
import {
  LS_FORECASTING_ONBOARDING_STEP,
  SCENARIO_ONBOARDING_STEP,
  SCENARIO_WITH_INVOICES_ONBOARDING_STEP
} from '../const';
import { ForecastType } from '../shared/onboarding-type-select';
import { useOnboardingUrlInfo } from '../utils/hooks';
import { usePredictionsInfoContext } from '../../detail/context/predictions-info-context';

export const OnboardingControlWhatYouSee = () => {
  const navigate = useNavigate();
  const { forecast } = usePredictionsInfoContext();
  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisationId } = useParams();

  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisationId || '';

  const { forecastType, isOnboardingScenarioRoute, isOnboardingScenarioWithInvoicesRoute } = useOnboardingUrlInfo();

  const handleNextClick = () => {
    if (!forecast) {
      return;
    }

    let nextStep;
    if (isOnboardingScenarioRoute) {
      nextStep =
        forecastType === ForecastType.FromScratch
          ? SCENARIO_ONBOARDING_STEP.SCRATCH_CUSTOMISE
          : forecastType === ForecastType.WithAutoPredictions
          ? SCENARIO_ONBOARDING_STEP.AUTO_PREDICTIONS_CUSTOMISE
          : SCENARIO_ONBOARDING_STEP.LYA_CUSTOMISE;
    } else {
      nextStep =
        forecastType === ForecastType.FromScratch
          ? SCENARIO_WITH_INVOICES_ONBOARDING_STEP.SCRATCH_CUSTOMISE
          : forecastType === ForecastType.WithAutoPredictions
          ? SCENARIO_WITH_INVOICES_ONBOARDING_STEP.AUTO_PREDICTIONS_CUSTOMISE
          : SCENARIO_WITH_INVOICES_ONBOARDING_STEP.LYA_CUSTOMISE;
    }

    navigate(
      `${getForecastByIdOnboardingUrl(
        workspaceId,
        organisationId,
        forecast.id,
        false,
        isOnboardingScenarioWithInvoicesRoute
      )}/${nextStep}${ROUTES.SALES}${location.search}`
    );
    localStorage.setItem(LS_FORECASTING_ONBOARDING_STEP, nextStep);
  };

  return (
    <div className={styles.contentContainer} style={{ position: 'relative' }}>
      <OnboardingPageTitle
        title={
          <FormattedMessage
            id="onboarding.control_what_you_see_here"
            defaultMessage="Control what you see here. Data is stored, daily..."
          />
        }
        description={
          <FormattedMessage
            id="onboarding.change_when_you_show_forecast_data"
            defaultMessage="Change when you show forecast data from as months pass, and your month-end bookkeeping is complete."
          />
        }
      />
      <Button disabled={!forecast} mb="30px" buttonType="primary" size="large" onClick={handleNextClick}>
        <FormattedMessage id="common.next" defaultMessage="Next" />
      </Button>

      <OnboardingPredictionsRouter />
    </div>
  );
};
